import React, { lazy } from "react";
import Loadable from "../components/Loadable";
import { routeCheck } from "app/data/roles";

const UsageStatement = Loadable(
  lazy(() => import("app/views/reports/usageStatement/UsageStatement"))
);
const ReservationOperatorList = Loadable(
  lazy(
    () =>
      import("app/views/reports/reservationOperator/ReservationOperatorList")
  )
);
const DebtorsList = Loadable(
  lazy(() => import("app/views/reports/debtors/DebtorsList"))
);

const reportsPaths = routeCheck(
  [
    { path: "/reports/usageStatement", element: <UsageStatement /> },
    {
      path: "/reports/reservationOperatorList",
      element: <ReservationOperatorList />,
    },
    {
      path: "/reports/DebtorsList",
      element: <DebtorsList />,
    },
  ],
  false
);

export default reportsPaths;
